import { render, staticRenderFns } from "./SummarySession.vue?vue&type=template&id=436a9906&scoped=true"
var script = {}
import style0 from "./SummarySession.vue?vue&type=style&index=0&id=436a9906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436a9906",
  null
  
)

export default component.exports